import React from 'react';

export class FieldRequiredIndicator extends React.Component {
	render() {
		return <span className="red-text">*</span>;
	}
}
